import { render, staticRenderFns } from "./invgilatorForMonitoring.vue?vue&type=template&id=5462e6e2&"
import script from "./invgilatorForMonitoring.vue?vue&type=script&lang=js&"
export * from "./invgilatorForMonitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports